import React from "react";
import { useSelector } from "react-redux";

import Modal from "components/common/modals/modal/Modal";
import PatientAnalytics from "components/pages/transmissions/modal/patient/tabs/generalInformation/tabs/analytics/PatientAnalytics";

const ReportTrends = ({ className = "" }) => {
  const {
    reportDetail: { patient },
  } = useSelector((state) => state.transmission);

  return (
    <>
      {patient?._id && (
        <Modal
          buttonTitle="Trends"
          modalTitle="Trends"
          maxWidth="xl"
          buttonVariant="outlined"
          color="secondary"
          data-action="trends-button"
          buttonClass={`view-pdf__button ${className}`}
          content={
            <div
              style={{
                marginBottom: "15px",
                height: "75vh",
                overflowY: "auto",
              }}
            >
              <PatientAnalytics patientId={patient?._id} />
            </div>
          }
        />
      )}
    </>
  );
};

export default ReportTrends;
